<template>
  <div style="height: 100%" :class="{
    'cpt-tab-page': true, 'cpt-tab-scroll': option.attribute.isScroll, 'cpt-tab-fiexd': isFiexd,
    'cpt-tab-top': option.attribute.position == 'top',
    'cpt-tab-bottom': option.attribute.position == 'bottom',
  }" :style="{
    ...postitionStyle,
    width: current.cptWidth + 'px',
    height: currentHeight,
    backgroundColor: option.attribute.backgroundColor,
    ...setTransform,

  }">
    <div
      :class="{ 'cpt-tab-page-scroll': option.attribute.isScroll, 'cpt-tab-direction': option.attribute.direction === 'column', 'cpt-tab-flex': option.attribute.isOpenLayout }"
      :style="{
        '---itemAllWidth': itemAllWidth,
        width: '100%',
        height: '100%',
        display: 'flex',
      }">
      <div v-for="(item, index) in tabs" :key="index"
        :class="{ 'active': item.value === activeValue, 'cpt-tab-item': true }"
        style="text-align: center;height: 100%;cursor: pointer" @click="changeTab(item.value, index)" :style="{
          width: Math.floor(1 / tabs.length * 100) + '%',
          fontSize: activeValue === item.value ? option.attribute.fontSize + 4 + 'px' : option.attribute.fontSize + 'px',
          color: option.attribute.textColor,

          /*borderBottom: activeIndex === index ? '1px solid '+option.attribute.textColor:'none',*/
          lineHeight: option.attribute.lineHeight + 'px',
          '---textColor': option.attribute.textColor,
          '---activeColor': activeColor,
          '---gradualColor': gradualColor,
          '---activeFontSize': option.attribute.activeFontSize == 0 ? option.attribute.fontSize + 'px' : option.attribute.activeFontSize + 'px',
          '---itemWidth': itemWidth,
          '---itemHeight': itemHeight,
          '---rowLeftNumber': index == (option.attribute.rowLeftNumber - 1) ? 'auto' : 'unset',
          '---columnTopNumber': index == (option.attribute.columnTopNumber - 1) ? 'auto' : 'unset',

          ...translateXComputed,
          // ...positionStyleComputed


        }">
        <div :class="{ 'cpt-tab-item-wrap': true, }" :style="{
          'backgroundColor': option.attribute.itemBackgroundColor,
          '---activeBg': option.attribute.activeBg,
          ...positionStyleComputed,
        }">

          <div
            :style="{ '---templateRadioSize': (option.attribute.templateRadioSize || 24) + 'px', '---radioChildrenSize': (option.attribute.templateRadioSize || 24) - 10 + 'px' }"
            :class="{ 'cpt-tab-item-radio': true, 'tab-radio-active': item.value === activeValue }"
            v-if="tabStyleType == 'radio'">
            <div class="children-radio"></div>
          </div>
          <span :style="{
            // 'filter': `brightness(${activeValue === item.value ? 1 : 0.8})`,
            'fontWeight': option.attribute.fontWeight,
            'fontFamily': textFamilyComputed(index),
            ...spanPositionStyleComputed,
          }">{{ item.label
            }}</span>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";
import { mapState, mapActions } from 'pinia'
import { useCombinationTabStore } from '@/stores/combinationTabStore'
import useIndex0Function from '@/views/viewsFunction/index0'
import { Tools } from '@/views/viewsFunction/designerMethods'
import options from '@/components/options'
const { CombinationTab } = useIndex0Function()
import { fileUrl } from '/env'
import { Message } from "tdesign-vue-next";
import { useButtonUpdateStore } from '@/stores/buttonUpdateStore'
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-tab",
  inject: ['Group'],
  props: {
    option: Object,
    current: Object,
    refMap: Object,
    components: Array,
    cacheComponents: Array,
    scale: Number,
    designCache: Object,
    drop: Function,
    cacheChoices: Object,  // 是个对象，不是数组
  },
  // mixins: [mixinsCom],
  watch: {
    'option.attribute.autoSwitch': {
      handler(newVal) {
        clearInterval(this.timer)
        this.timer = null
        if (newVal === true) {
          this.autoSwitch();
        }
      }
    },
    'option.attribute.interval': {
      handler() {
        clearInterval(this.timer)
        this.timer = null
        this.autoSwitch();
      },
    },
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // console.log('tab--show--',val);
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.interaction.eventList": {
      deep: true,
      handler(val) {
        const obj = val.find(x => x.intType === "forceRefresh")
        if (!obj) {
          this.resetMultSelectComp()
        }
      }
    },
    'option.attribute.tabStyleIndex': {
      handler(value, oldValue) {
        // console.log(value, oldValue, 'asodkosaksodko');
        // if (typeof value == 'number' && value != oldValue) {
        //   console.log('执行自动创建选项卡关联组合控件..')
        //   this.createGroupComponents(value)
        // }
        this.getTemplateTabSetStyle()
      },
    },

    // 'current': {
    //   handler(value) {
    //     let index = value.tabIndex
    //     // this.changeTab(this.tabs[index]?.value, index)
    //     // 编辑时显示隐藏
    //     // CombinationTab.setTabContentShowHide({
    //     //   cacheComponents: this.cacheComponents,
    //     //   refMap: this.refMap,cp
    //     //   currentTab: this.current
    //     // })
    //     // CombinationTab.setPreviewTabContentShowHide({ current: this.current, refMap: this.refMap, components: this.components })
    //   },
    //   deep: true,
    // }
  },
  computed: {
    ...mapState(useCombinationTabStore, ['tabStyleList', 'tabCache']),
    spanPositionStyleComputed() {
      return this.option.attribute.isOpenLayout ? this.positionStyleComputed : {}
    },
    textFamilyComputed() {
      return index => {
        let isActive = this.activeValue === this.tabs[index]?.value
        const { activeTextFamily, textFamily } = this.option.attribute
        return isActive ? activeTextFamily ? activeTextFamily : textFamily : textFamily
      }
    },
    activeColor() {
      const { enableGradual, activeColor, textColor } = this.option.attribute
      // let enableGradual = this.option.attribute?.enableGradual
      // let gradualColor = this.option.attribute?.gradualColor
      if (enableGradual === 1) {
        return activeColor ? activeColor : textColor
      } else {
        return 'transparent'
      }


    },
    gradualColor() {
      let enableGradual = this.option.attribute?.enableGradual
      let gradualColor = this.option.attribute?.gradualColor
      if (enableGradual == 1) {
        return ''
      }
      if (!gradualColor || gradualColor.length <= 0) {
        return ''
      }
      console.log(gradualColor, 'gradualColor');
      let toP = `to ${enableGradual == 2 ? 'right' : 'bottom'}`
      return `linear-gradient(${toP}, ${gradualColor.toString()})`

    },
    positionStyleComputed() {
      const { textPositionY, textPositionX } = this.option.attribute
      let style = {}
      switch (textPositionY) {
        case 'top':
          style['align-items'] = 'flex-start'
          break;
        case 'center':
          style['align-items'] = 'center'
          break;
        case 'bottom':
          style['align-items'] = 'flex-end'
          break;
        default:
          style['align-items'] = 'flex-start'
          style['margin-top'] = textPositionY + 'px'
          break;
      }
      switch (textPositionX) {
        case 'left':
          style['justify-content'] = 'flex-start'
          break;
        case 'center':
          style['justify-content'] = 'center'
          break;
        case 'right':
          style['justify-content'] = 'flex-end'
          break;
        default:
          style['justify-content'] = 'flex-start'
          style['margin-left'] = textPositionX + 'px'
          break;
      }
      return style
    },
    currentHeight() {
      let height = Math.ceil(this.current.cptHeight / this.scale?.containerScaleX) + 'px'
      if (this.isDesign) {
        return this.current.cptHeight + 'px'
      } else {
        return height
      }
    },
    itemWidth() {
      const { itemWidth, rowItemWidth, isOpenLayout } = this.option.attribute
      if (isOpenLayout) {
        return typeof rowItemWidth === 'string' ? 'auto' : rowItemWidth + 'px'
      } else {
        return itemWidth + 'px'
      }
    },
    itemHeight() {
      const { columnItemHeight, isOpenLayout } = this.option.attribute
      if (isOpenLayout) {
        return typeof columnItemHeight === 'string' ? 'auto' : columnItemHeight + 'px'
      } else {
        return '100%'
      }
    },
    itemAllWidth() {
      const { itemWidth } = this.option.attribute
      if (itemWidth) {
        return (itemWidth * this.tabs.length) + 'px'
      } else {
        return '100%'
      }

    },
    isFiexd() {
      return !this.isDesign && this.option.attribute.isFiexd
    },
    isDesign() {
      return location.href.includes('/design')
    },
    postitionStyle() {

      let y = this.option.attribute.postitionY
      let x = this.option.attribute.postitionX
      let postitionY = y ? y : this.current.cptY
      let postitionX = x ? x : this.current.cptX
      if (this.option.attribute.isFiexd) {
        if (this.option.attribute.position == 'top' || this.option.attribute.position == 'bottom') {
          postitionY = y ? y : 0
          // postitionX = x ? x : 0
        }
      }
      return {
        '---postitionY': postitionY + 'px',
        '---postitionX': postitionX + 'px',
      }
    },
    setTransform() {
      if (!this.isFiexd) {
        return {}
      }
      let containerScaleX = this.scale?.containerScaleX
      let containerScaleY = this.scale?.containerScaleY
      let transform = {
        transformOrigin: '0 0',
        transform: this.designCache?.scaleType === 1 ? `scaleX(${containerScaleX}) scaleY(${containerScaleY})` : `scaleX(${containerScaleX})`
      }
      return transform
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
    translateXComputed() {
      let obj = {}
      const { rowMarginLeft, rowMarginRight } = this.option.attribute
      if (rowMarginLeft) {
        obj['padding-left'] = `${rowMarginLeft}px`
      }
      if (rowMarginRight) {
        obj['padding-right'] = `${rowMarginRight}px`
      }
      console.log(obj, 'dqwdqdqdqdwqdwqdwqdqw');
      return obj
    }
  },
  data() {
    return {
      tabs: [],
      uuid: null,
      activeValue: '',
      timer: null,
      fileUrl,
      tabStyleType: false,
      parasValue: null
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //判断此控件在九宫格里面就不请求数据
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }

    this.getTemplateTabSetStyle()

  },
  mounted() {
    if (this.option.attribute.autoSwitch === true) {
      this.autoSwitch();
    }
    if (!this.option.attribute.hasOwnProperty('textPositionY')) {
      this.option.attribute.textPositionY = 'center'
    }
    if (!this.option.attribute.hasOwnProperty('textPositionX')) {
      this.option.attribute.textPositionX = 'center'
    }
    this.setTabDefaultValue()
    this.setTabGroupValue()
  
    setTimeout(() => {
    // 修文特殊处理
    // const xw_tab_page = location.href.includes('/v/703b7590649c1e6d138993a429e3c2db')
    let xw_tab_page = ''
    if(xw_tab_page) {
      // const asd = refMap['div423cfac0-4a26-11ef-8445-b3d89b1d78fd']
      
      console.log(document.querySelector('#div423cfac0-4a26-11ef-8445-b3d89b1d78fd'),'qwdijwqjiqijwwjiq')
      let tab_s = document.querySelector('#div423cfac0-4a26-11ef-8445-b3d89b1d78fd').children[0].children[0].children
      let item = tab_s[tab_s.length - 2]
      console.log(item,'qwduqwduhqwuhw')
      item.remove()
      Array.from(tab_s).forEach(tab_item => {
        // tab_item.style.width = '13%'
        console.log(tab_item,'按实际地阿斯加手机')
        tab_item.classList = 'xw_diy'
      })
      let border_s = document.querySelector('#div4ab19a31-5615-11ef-8c2a-8ffb90a5bb90')

      console.log(border_s,'border_sborder_sborder_sborder_sborder_s')
      border_s.remove()
      

    }
    }, 500)
 
  

  },
  methods: {
    ...mapActions(useCombinationTabStore, ['setScaleStyleHeight', 'setTabCache', 'setTabItemCache']),
    cptClickHandler(...args) {
      this.$emit('clickHandler', ...args)
    },
    // 校验选项卡tabGroup与数据是否一致 - 有问题 需要研究
    verifyTabGroupConsistency() {
      let tabTextData = this.getCurrentDatatext()
      let tabGroup = this.current?.tabGroup
      if (tabTextData.options.length == 0) {
        return
      }
      // 检查tabGroup对象是否包含所有数据的键
      const hasAllKeys = tabTextData.options.every(item => tabGroup && tabGroup?.hasOwnProperty(item.value));
      // 如果tabGroup缺少数据中的任何键，更新tabGroup
      if (!hasAllKeys) {
        tabTextData.options && tabTextData.options.forEach((item, index) => {
          let key = item.value
          if (tabGroup && !tabGroup.hasOwnProperty(key)) {
            // 将缺失的键从数据中复制到tabGroup中
            this.current.tabGroup[key] = []
          }
        });
      }

      // 对于tabGroup中多余的键，删除它们：
      const keysB = this.current?.tabGroup && Object.keys(this.current?.tabGroup);
      keysB && keysB.forEach(key => {
        let isKeyInKeysA = tabTextData.options.some(k => k.value == key)

        if (!isKeyInKeysA) {
          // 批量删除不在数据中的tabGroup键的子组件
          this.current.tabGroup[key].forEach(childId => {
            let delTabChildItem = this.cacheComponents?.find(item => item.id == childId)
            CombinationTab.delete({ deleteItem: delTabChildItem, cacheComponents: this.cacheComponents });
          })
          // 删除不在数据中的tabGroup键
          delete this.current.tabGroup[key];
        }
      });

    },
    // 设置选项卡tabGroup的key
    setTabGroupValue() {
      let tabGroupArray = this.current?.tabGroup && Object.keys(this.current?.tabGroup)
      if (tabGroupArray && tabGroupArray.length === 0) {
        let dataText = this.getCurrentDatatext()
        dataText.options.forEach(item => {
          this.current.tabGroup[item.value] = []
        })
      }
    },
    areArraysEqual(arr1, arr2) {
      // 1. 比较数组长度
      if (arr1.length !== arr2.length) {
        return false;
      }

      // 2. 逐元素比较
      for (let i = 0; i < arr1.length; i++) {
        const elem1 = arr1[i];
        const elem2 = arr2[i];

        // 基本数据类型直接比较
        if (elem1 !== elem2) {
          return false;
        }

        // 处理复杂数据类型（如对象、数组）
        else if (
          typeof elem1 === 'object' &&
          elem1 !== null &&
          elem2 !== null &&
          !(elem1 instanceof Date && elem2 instanceof Date)
        ) {
          if (Array.isArray(elem1)) {
            if (!areArraysEqual(elem1, elem2)) {
              return false;
            }
          } else if (Object.getPrototypeOf(elem1) === Object.prototype) {
            const keys1 = Object.keys(elem1);
            const keys2 = Object.keys(elem2);

            if (!areArraysEqual(keys1, keys2)) {
              return false;
            }

            for (const key of keys1) {
              if (!areArraysEqual(elem1[key], elem2[key])) {
                return false;
              }
            }
          }
        }
      }

      // 若所有元素均一致，则返回true
      return true;
    },
    // 当url参数中带有tabIndex时 设置默认选项卡显示
    setTabDefaultValue() {
      let isDefault = this.option.attribute.tabDefaultKey
      let isDefaultUrlKey = this.option.attribute.tabDefaultURLKey
      let urlKey = Tools.getQueryParamsAsObject()[isDefaultUrlKey]


      if (urlKey) {
        let isValue = this.tabs.find(item => item.value == urlKey)
        let tabIndex = this.tabs.findIndex(item => item.value == urlKey)
        isValue && this.changeTab(urlKey, tabIndex)
        return
      } else if (isDefault) {
        let tabIndex = this.tabs.findIndex(item => item.value == isDefault)
        this.changeTab(isDefault, tabIndex)
      }
    },
    autoSwitch() {
      const that = this;
      let index = that.tabs.findIndex((item => { return item.value === that.activeValue })) + 1
      this.timer = setInterval(() => {
        if (index === that.tabs.length) {
          index = 0;
        }
        this.changeTab(that.tabs[index].value, index)
        index++
      }, this.option.attribute.interval * 1000)
    },

    changeTab(value, index) {
      console.log('选项卡切换', value, index);
      this.activeValue = value;
      // this.option.cptDataForm.tabIndex = index
      this.current.tabIndex = index || 0
      this.tabClickHandler(this.current)
      CombinationTab.setAutoHeight(this.current, this.components, { scale: this.scale, refMap: this.refMap, setScaleStyleHeight: this.setScaleStyleHeight })
      CombinationTab.setTabContentShowHide({
        cacheComponents: this.cacheComponents,
        refMap: this.refMap,
        currentTab: this.current
      })
      CombinationTab.setPreviewTabContentShowHide({ current: this.current, refMap: this.refMap, components: this.components })

      this.setTabContentTop()

      // 模板组件处理
      this.setTemplateCompHandler(value, index)

      this.$emit("clickHandler", this.option.interaction, value, value, 'cpt-tab', value)

      window.postMessage({
        type: "TABCHANGEMESSAGE",
        data: JSON.stringify({ activeKey: value, options: this.tabs, tabIndex: index })
      })

      if (this.option.attribute.position == 'bottom') {
        console.log("====底部tab切换====");
        window.top.document.title = this.tabs[index].label;
      }
      // console.log('changeTab-current-',this.current);
      this.$nextTick(() => {
        this.forceRefreshSelectComps()
      })
    },
    // 操作时 - 处理模板组件
    setTemplateCompHandler(value, index) {
      console.log(value, index, 'asdoksaodkado');
      console.log(this.components, this.cacheComponents, 'componentscomponentscomponents');

      this.setTemplateImageHandler(value)

    },
    // 操作时 - 处理图片模板组件
    setTemplateImageHandler(tabCurrentKey) {
      let components = this.components || this.cacheComponents
      let images = components.filter(image => image.cptKey === 'cpt-image' && image.cptType == "combination-group")
      // 查询关联的选项卡图片组件
      for (let i = 0; i < images.length; i++) {
        const imageItem = images[i];
        const { tabGroupValue } = imageItem.cptOption.attribute
        // 没有配置选中图片, 跳过
        if (!imageItem.cptOption.attribute.activeUrl) {
          continue
        }
        if (imageItem.cptOption.attribute.isTabGroupId != this.current.id) {
          continue
        }
        if (tabGroupValue == tabCurrentKey) {
          this.refMap[imageItem.id].setValue(imageItem.cptOption.attribute.activeUrl)
        } else {
          this.refMap[imageItem.id].setValue(imageItem.cptOption.attribute.url)
        }
      }
    },
    setTabContentTop() {
      let switchTop = this.current.cptOption.attribute.switchTop
      let previewPage = this.refMap['previewPage']
      if (switchTop && previewPage) {
        previewPage.scrollTop = 0

      }
    },
    forceRefreshSelectComps() {
      // console.log('cacheComponents--',this.cacheComponents);
      if (!this.cacheComponents || this.cacheComponents.length === 0) return
      const eventList = this.current.cptOption.interaction.eventList
      // console.log('eventList--',eventList);
      const index = eventList.findIndex(x => x.intType === "forceRefresh")
      const obj = eventList[index]
      if (!obj) return this.resetMultSelectComp()
      const allIds = this.cacheComponents.map(item => item.id)
      // 同步本地数据
      obj.data = obj.data.filter(item => allIds.includes(item.id))
      const { data, tabIndexList } = obj
      if (data.length === 0) {
        eventList.splice(index, 1)
        return
      }
      if (!tabIndexList?.includes(this.current.tabIndex)) return
      // console.log('data--',data);
      data.forEach(item => {
        if (item.index !== this.current.tabIndex) return
        let target = this.refMap[item.id]
        if (!target) return
        if (target.$options.name === 'cpt-ninegrid') return target.init()
        if (target && target.refreshCptData) {

          target.refreshCptData()
        } else {
          console.log('页签强刷子组件为渲染：', target);
        }
      })
    },
    resetMultSelectComp() {
      const btnUpdateStore = useButtonUpdateStore()
      btnUpdateStore.resetMultSelectComp(this.current.id)
    },

    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm, paras), this.components)
    },
    loadData(cptDataForm, paras) {
      getDataJson(cptDataForm, paras, (res) => {
        let resultIsArray = Array.isArray(res) ? res.resStr : res
        this.tabs = resultIsArray.options;
        this.parasValue = paras
        // 重新设置关联组件
        this.option.attribute.isDefault = res.value
        //监听里面会执行的
        this.verifyTabGroupConsistency()
        // this.changeTab(res.value, 0)


        // this.setTabCache()
        // this.setTabTemplate()
      });
    },
    /**
     * 点击时对组合选项卡中某个组件进行特定操作
     * @param {*} current // 当前点击的tab index
     */
    tabClickHandler(current) {
      if (current.cptType != "combination") {
        return
      }
      // let currentTab = current.tabGroup[`index-${current.tabIndex}`]
      let currentTabGroup = CombinationTab.getCurrentTab(current)
      let currentTab = current.tabGroup[currentTabGroup]

      if (!currentTab || !currentTab.length) {
        return
      }
      currentTab.forEach(item => {
        let doHas = this.refMap[item]?.computeColWidth
        if (!doHas) {
          return
        }
        // 调用滚动表格函数
        this.refMap[item]?.computeColWidth()
      });
    },

    // 创建新组件
    createGroupComponents() {
      if (!this.isDesign) {
        return
      }
      const { tabStyleIndex } = this.option.attribute
      // const tabStyleList = this.combinationTab.tabStyleList
      const tabStyleList = this.tabStyleList

      if (typeof tabStyleIndex !== 'number') {
        return false
      }
      const currentTabTemplate = tabStyleList[tabStyleIndex]

      // 设置样式
      this.setTabTemplateStyle(currentTabTemplate)
      // 设置控件值
      this.setTabTemplateCpt(currentTabTemplate)

      this.refreshCptData(this.option.cptDataForm);
      // 创建选项卡组件
      this.createTabGroupComps(currentTabTemplate)
    },
    // 
    setTabTemplate() {
      const { tabStyleIndex } = this.current.cptOption.attribute
      if (!tabStyleIndex || isNaN(tabStyleIndex)) {
        return
      }
      console.log('qdoksodokasdokasdkosadoksaokad');
      // this.clearTemplateComps()
      // this.createGroupComponents()
    },
    // 设置模版样式
    setTabTemplateStyle(dataComponents) {
      for (const key in dataComponents.attribute) {
        let value = dataComponents.attribute[key]
        this.option.attribute[key] = value
      }
    },
    // 设置选项卡
    setTabTemplateCpt(dataComponents) {
      for (const key in dataComponents.cpt) {
        let value = dataComponents.cpt[key]
        if (key === 'position') {
          let groups = this.current.group
          let border = this.cacheComponents.find(item => item?.cptType === 'combination-border' && groups.includes(item.id))
          if (!border) {
            return console.error('找不到选项卡内容组件!')
          }
          switch (value) {
            case 'bottom':
              this.current.cptY = border.cptHeight + border.cptY
              this.current.cptX = border.cptX
              break;
            case 'top':
              this.current.cptY = border.cptY
              this.current.cptX = border.cptX
              break;
            case 'left':
              this.current.cptX = border.cptX
              this.current.cptY = border.cptY
              break;
            case 'right':
              this.current.cptX = border.cptX + border.cptX
              this.current.cptY = border.cptY
              break;
            default:
              break;
          }

        } else {
          this.current[key] = value
        }
      }
    },
    // 创建关联组件
    async createTabGroupComps(currentTabTemplate) {

      let tabTemplateComps = currentTabTemplate.components
      let dataTextData = this.getCurrentDatatext()
      let newTabTemplateComps = []
      if (!dataTextData.options) {
        console.error('创建选项卡模板子组件失败：数据集数据为空');
        Message.error('创建选项卡模板子组件失败：数据集数据为空')
        return
      }
      tabTemplateComps.forEach((compItem, compIndex) => {
        let comps = dataTextData.options.map((item, index) => {
          const cptKey = compItem.component;
          let itemOption = Tools.findCptKeyInNestArray(options, cptKey);
          let compOption = JSON.parse(JSON.stringify(itemOption[0] || []));
          compOption.option.attribute.isTabGroupId = this.current.id;
          compOption.option.attribute.cptIndex = this.current.cptOption.attribute.cptIndex + 10000 + index;
          compOption.type = 'combination-group'

          console.log(this.current.cptOption.attribute.cptIndex + 10000 + index, ">>>>;a.sd;.d;sd;d");

          compOption = this.setItemCompOption({ compOption, dataTextData, index, item, compItem })


          console.log(compOption, 'compOption');
          // if (callback) {
          // compOption = callback({ compOption, dataTextData, index, item, createComps })
          // }
          return compOption
        })
        newTabTemplateComps = [...newTabTemplateComps, ...comps]
      })
      console.log(newTabTemplateComps, 'newTabTemplateComps');
      // 执行子组件批量创建
      const dropPromises = newTabTemplateComps.map(async option => this.drop({
        type: 'HANLERDROP',
        handler: option,
      }));

      try {
        await Promise.all(dropPromises);
        console.log('所有 drops 执行完成.');
        // 组合控件
        this.initGroupComps()
        // 执行完成后
      } catch (error) {
        console.error('当前 drops 执行失败:', error);
      }

    },

    setItemCompOption({ compOption, dataTextData, index, item, compItem }) {
      switch (compOption.cptKey) {
        case 'cpt-iconfont':
          return this.setItemIcons(...arguments)
        case 'cpt-badge':
          return this.setItemBadge(...arguments)
        case 'cpt-image':
          return this.setItemImages(...arguments)
        default:
          break;
      }
    },
    // 创建图标回调函数
    setItemIcons({ compOption, dataTextData, index, item }) {
      console.log('set Icons:', compOption, item)
      // 获取选项卡
      const tab = this.current
      // 设置选项卡索引值
      compOption.option.attribute.tabGroupValue = dataTextData.options[index].value;
      compOption.option.attribute.tabIndex = index
      // 设置图标样式
      compOption.option.attribute.iconfont = {
        font_class: item.icon
      }
      compOption.option.attribute.color = item.color

      let eachWidth = (tab.cptWidth / dataTextData.options.length)
      let haslfWidth = eachWidth / 2
      let iconHaslfWidth = compOption.width / 2
      compOption.cptX = tab.cptX + ((eachWidth * index) + haslfWidth - iconHaslfWidth)
      compOption.cptY = tab.cptY + 10

      return compOption
    },
    // 创建图片回调函数
    setItemImages({ compOption, dataTextData, index, item, compItem }) {
      console.log('set Images:', compItem, compOption, item)
      // 获取选项卡
      const tab = this.current
      // 设置选项卡索引值
      compOption.option.attribute.tabGroupValue = dataTextData.options[index]?.value;
      compOption.option.attribute.tabIndex = index

      compOption.option.attribute.url = compItem.url
      compOption.option.attribute.activeUrl = compItem.activeUrl
      compOption.option.cptDataForm.dataText = JSON.stringify({ url: location.origin + compItem.url })
      compOption.width = compItem.width
      compOption.height = compItem.height

      console.log(compOption.option.attribute.zIndex, this.current.cptOption.attribute.cptIndex, 'qijwdijqwid');
      let cptIndexString = String(this.current.cptOption.attribute.cptIndex)
      let newCptIndex = ''
      for (let i = 0; i < cptIndexString.length; i++) {
        newCptIndex += i == 0 ? cptIndexString[i] : '0'

      }
      console.log(newCptIndex, 'newCptIndex');
      // let newCptIndex = cptIndex.slice(0,1) + cptIndex.length - 1
      compOption.option.attribute.cptIndex = newCptIndex

      // compOption.option.attribute.zIndex = 1
      // delete compOption.option.attribute.cptIndex

      // let eachWidth = (tab.cptWidth / dataTextData.options.length)
      // let haslfWidth = eachWidth / 2
      // let iconHaslfWidth = compOption.width / 2
      // compOption.cptX = tab.cptX + ((eachWidth * index) + haslfWidth - iconHaslfWidth)
      // compOption.cptY = tab.cptY + 10
      compOption.cptX = tab.cptX + (compItem.width * index) + (10 * index)
      compOption.cptY = tab.cptY - tab.cptHeight
      // 最后一项设置选项卡
      if ((index + 1) === dataTextData.options.length) {
        this.current.cptY = tab.cptY - tab.cptHeight
      }

      return compOption
    },
    // 设置角标
    setItemBadge({ compOption, dataTextData, index, }) {
      // 获取选项卡
      const tab = this.current
      compOption.option.attribute.tabGroupValue = dataTextData.options[index].value;
      compOption.option.attribute.tabIndex = index
      compOption.width = 30
      compOption.height = 40

      let eachWidth = (tab.cptWidth / dataTextData.options.length)
      let haslfWidth = eachWidth / 2
      let iconHaslfWidth = compOption.width / 2
      compOption.cptX = tab.cptX + ((eachWidth * index) + haslfWidth + iconHaslfWidth)
      compOption.cptY = tab.cptY

      return compOption
    },
    // 组合控件
    initGroupComps() {

      let tabGroupComps = this.cacheComponents.filter(item => {
        return item.cptOption.attribute.isTabGroupId == this.current.id
      })
      tabGroupComps.forEach(item => {
        item.groupCompName = this.current.groupCompName
        let tabHasComp = this.current.group.includes(item.id)
        if (!tabHasComp) {
          this.current.group.push(item.id)
        }
      })

    },
    // 清除选项卡模板
    clearTemplateComps() {
      const allComps = this.cacheComponents.filter(item => {
        let isTabGroupComp = item.cptOption.attribute.isTabGroupId == this.current.id
        return isTabGroupComp
      })
      allComps.forEach(item => {
        let index = this.cacheComponents.findIndex(c => c.id == item.id)
        if (index != -1) this.cacheComponents.splice(index, 1)
      })
    },


    // 获取当前选项卡的选项值
    getCurrentDatatext() {
      let { dataText } = this.option.cptDataForm
      if (!dataText) {
        return
      }
      return JSON.parse(dataText)
    },

    // 查询当前选项卡是否启用修改选项卡样式
    getTemplateTabSetStyle() {
      const { tabStyleIndex } = this.option.attribute
      let template = this.tabStyleList[tabStyleIndex]
      if (!template && !template?.setTabStyle) {
        return
      }

      this.tabStyleType = template.setTabStyle
    },



  },
  beforeUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped>
.cpt-tab-page .active {
  font-size: var(---activeFontSize) !important;

}

.cpt-tab-page .cpt-tab-item-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cpt-tab-page .active .cpt-tab-item-wrap {
  background: var(---activeBg) !important;
}

.cpt-tab-page .active span {
  background-image: var(---gradualColor) !important;
  background-clip: text;
  color: var(---activeColor) !important;
}


.cpt-tab-flex .cpt-tab-item {
  display: inline-block !important;
  width: var(---itemWidth) !important;
  height: var(---itemHeight) !important;
  margin-right: var(---rowLeftNumber);
  margin-bottom: var(---columnTopNumber);
}

.cpt-tab-flex .cpt-tab-item span {
  width: 100% !important;
  height: 100% !important;
}

.cpt-tab-fiexd {
  position: fixed;
  top: var(---postitionY);
  left: var(---postitionX);
}

.cpt-tab-top {
  top: var(---postitionY) !important;
  left: var(---postitionX) !important;
  bottom: unset !important;
}

.cpt-tab-bottom {
  bottom: var(---postitionY) !important;
  left: var(---postitionX) !important;
  top: unset !important;
}

.cpt-tab-direction {
  flex-direction: column;
}

.cpt-tab-direction .cpt-tab-item {
  width: 100% !important;
}


.cpt-tab-page {
  height: 100%;
  overflow: hidden;
}

.cpt-tab-scroll {
  overflow-x: scroll;
  overflow-y: hidden;
}


.cpt-tab-page-scroll {
  width: var(---itemAllWidth) !important;
}

.cpt-tab-page-scroll .cpt-tab-item {
  width: var(---itemWidth) !important;

}

.cpt-tab-page .cpt-tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.cpt-tab-page .cpt-tab-item span {
  /* height: 100%; */
  display: flex;
  align-items: center;
}


/* 单选样式 */
.tab-radio-active {}

.tab-radio-active::before,
.tab-radio-active::after {
  border-color: var(---activeColor) !important;
}

.tab-radio-active::after {
  border-color: var(---activeColor) !important;

}

.tab-radio-active .children-radio {
  background: var(---activeColor) !important;
  border-color: var(---activeColor) !important;
  filter: opacity(0.7)
}

.cpt-tab-item-radio {
  position: relative;
  width: var(---templateRadioSize);
  height: var(---templateRadioSize);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.cpt-tab-item-radio::before {
  content: '';
  width: var(---templateRadioSize);
  height: var(---templateRadioSize);
  border-radius: var(---templateRadioSize);
  border: 2px solid var(---textColor);
  position: absolute;
}



.cpt-tab-item-radio::after,
.children-radio {
  content: '';
  width: var(---radioChildrenSize);
  height: var(---radioChildrenSize);
  border-radius: var(---radioChildrenSize);
  /* background: rgb(72, 116, 203); */
  border: 2px solid var(---textColor);
  position: absolute;
}

.xw_diy {
  width: 13% !important;
  margin-left: -4px !important;
}
</style>
